import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { WrappedCardListItemSubComponent } from '../CardListItem/cardListItemSubComponent';
import { CardListItemTitleWithSubtitle, CardListItemTitleWithSubtitleProps } from '../CardListItemTitleWithSubtitle/CardListItemTitleWithSubtitle';
export type CardListItemTitleProps = PropsWithChildren<Omit<CardListItemTitleWithSubtitleProps, 'children'>>;
export const CardListItemTitle: WrappedCardListItemSubComponent<CardListItemTitleProps> = props => {
  const $ = _c(10);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
  } else {
    children = $[3];
    remainingProps = $[4];
  }
  let t1;
  if ($[5] !== children) {
    t1 = () => ({
      title: children,
      subtitle: null
    });
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== remainingProps || $[8] !== t1) {
    t2 = <CardListItemTitleWithSubtitle {...remainingProps}>{t1}</CardListItemTitleWithSubtitle>;
    $[7] = remainingProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};